// 获取地址栏参数
export function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var result = window.location.search.substr(1).match(reg)
  return result ? decodeURIComponent(result[2]) : null
}
export function getQueryStringBase(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var result = window.location.search.substr(1).match(reg)
  return result ? result[2] : ''
}
export function getQueryHashString(name) {
  const hash = window.location.hash.substring(window.location.hash.indexOf('?'))
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var result = hash.substr(1).match(reg)
  return result ? decodeURIComponent(result[2]) : null
}
// 判断环境
const ua = window.navigator.userAgent
export const isAlipay = ua.indexOf('AliApp(AP') > -1
export const isWechat = ua.indexOf('MicroMessenger') > -1
export const isQQ = ua.indexOf('QQ/') > -1
export const isIOS = ua.indexOf('like Mac OS X') > -1

// 用支付宝打开（已失效）
export function openWithAlipay(url) {
  // window.location.href = `alipays://platformapi/startapp?appId=20000067&url=${encodeURIComponent(url)}`
  window.location.href = url
}
